/**
 * NotificationData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { NotificationInfo } from './notification_info'
import type { NotificationResponseData } from './notification_response_data'
import type { NotificationStatsData } from './notification_stats_data'

/**
 * NotificationData
 */
export interface NotificationData {
  /** 通知基础信息 */
  info?: NotificationInfo
  sender_info?: any
  target_info?: any
  /** 响应列表 */
  responses?: NotificationResponseData[]
  /** 统计信息 */
  stats?: NotificationStatsData
}

/**
 * NotificationData Schema
 */
export const NotificationDataSchema: SchemaDefinition = {
  properties: {
    info: {
      $ref: 'NotificationInfo',
      description: '通知基础信息',
      label: '通知基础信息',
    },
    sender_info: { type: 'any', description: '' },
    target_info: { type: 'any', description: '' },
    responses: {
      description: '响应列表',
      format: '[]*model.NotificationResponseData',
      items: { $ref: 'NotificationResponseData', description: '' },
      type: 'array',
      label: '响应列表',
    },
    stats: {
      $ref: 'NotificationStatsData',
      description: '统计信息',
      label: '统计信息',
    },
  },
  type: 'object',
}
